<div class="eek2-root" *ngIf="vm.current as current">
	<div class="eek2-card">
		<div class="eek2-note disclaimer">
			<strong>{{ copy.disclaimerTitle }}</strong>
			<div>{{ copy.disclaimerBody }}</div>
		</div>

		<div *ngIf="vm.suicideRisk" class="eek2-note safety">
			<strong>{{ copy.suicideTitle }}</strong>
			<div>{{ copy.suicideBody(vm.suicideValue) }}</div>
		</div>

		<div *ngIf="vm.comorbid" class="eek2-note flag">
			<strong>{{ copy.comorbidTitle }}</strong>
			<div>{{ copy.comorbidBody }}</div>
		</div>

		<div class="eek2-meta">{{ formatDate(current.timestamp) }}</div>

		<div class="eek2-table-scroll">
			<table class="eek2-table">
				<thead>
					<tr>
						<th>{{ copy.colSubscale }}</th>
						<th>{{ copy.colScore }}</th>
						<th>{{ copy.colCutoff }}</th>
						<th>{{ copy.colStatus }}</th>
					</tr>
				</thead>
				<tbody>
					<tr><th colspan="4">{{ copy.mainSubscales }}</th></tr>
					<tr *ngFor="let row of vm.mainRows">
						<td><strong>{{ row.code }}</strong> {{ row.label }}</td>
						<td [class.eek2-over]="row.above">{{ row.score }} / {{ row.max }}</td>
						<td>&ge; {{ row.cutoff }}</td>
						<td [class.eek2-over]="row.above">{{ row.above ? '⚑ ' : '' }}{{ row.status }}</td>
					</tr>
					<tr><th colspan="4">{{ copy.additionalSubscales }}</th></tr>
					<tr *ngFor="let row of vm.additionalRows">
						<td><strong>{{ row.code }}</strong> {{ row.label }}</td>
						<td [class.eek2-over]="row.above">{{ row.score }} / {{ row.max }}</td>
						<td>&ge; {{ row.cutoff }}</td>
						<td [class.eek2-over]="row.above">{{ row.above ? '⚑ ' : '' }}{{ row.status }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="eek2-card">
		<h3 class="eek2-section-title">{{ copy.itemResponsesTitle }}</h3>
		<div class="eek2-table-scroll">
			<table class="eek2-table eek2-th-itemtable">
				<thead>
					<tr>
						<th>{{ copy.colItem }}</th>
						<th></th>
						<th>{{ copy.colResponse }}</th>
						<th>{{ copy.colSubscale }}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of vm.itemRows" [class.eek2-th-item5]="row.risk">
						<td>{{ row.order }}</td>
						<td>{{ row.text }}</td>
						<td><strong>{{ row.value != null ? row.value : '–' }}</strong> {{ row.scaleLabel }}</td>
						<td [class.eek2-th-noscore]="row.notScored">{{ row.tag }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="eek2-card">
		<h3 class="eek2-section-title">{{ copy.historyTitle }}</h3>
		<div class="eek2-table-scroll">
			<table class="eek2-table">
				<thead>
					<tr>
						<th>{{ copy.date }}</th>
						<th *ngFor="let row of vm.mainRows">{{ row.code }}</th>
						<th *ngFor="let row of vm.additionalRows">{{ row.code }}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let record of vm.history" [class.eek2-current]="record.id === current.id">
						<td>{{ formatDate(record.timestamp) }}</td>
						<td *ngFor="let row of vm.mainRows" [class.eek2-over]="record.scores[row.code].above">{{ record.scores[row.code].score }}{{ record.scores[row.code].above ? ' ⚑' : '' }}</td>
						<td *ngFor="let row of vm.additionalRows" [class.eek2-over]="record.scores[row.code].above">{{ record.scores[row.code].score }}{{ record.scores[row.code].above ? ' ⚑' : '' }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="eek2-trend">
			<div class="eek2-trend-card" *ngFor="let trend of vm.trendCards">
				<h4>{{ trend.label }} <span class="eek2-trend-meta">({{ trend.code }})</span></h4>
				<div class="eek2-trend-meta">{{ trend.meta }}</div>
				<svg class="eek2-spark" viewBox="0 0 200 56" role="img" aria-label="trend">
					<line x1="4" [attr.y1]="trend.sparkline.cutoffY" x2="196" [attr.y2]="trend.sparkline.cutoffY" stroke="var(--eek2-ink)" stroke-width="1" stroke-dasharray="3 3" opacity="0.55"></line>
					<polyline *ngIf="vm.history.length > 1" [attr.points]="trend.sparkline.pathPoints" fill="none" [attr.stroke]="trend.sparkline.lineColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></polyline>
					<circle *ngFor="let dot of trend.sparkline.dots" [attr.cx]="dot.x" [attr.cy]="dot.y" r="2.6" [attr.fill]="dot.color"></circle>
				</svg>
			</div>
		</div>
	</div>
</div>
